import React from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'
import { OutboundLink as Link } from 'gatsby-plugin-google-analytics'
import MainLayout from '../components/layout/MainLayout'
import Logo from '../components/insipidstudio/Logo'
import Discord from '../components/social/Discord'
import Instagram from '../components/social/Instagram'
import Reddit from '../components/social/Reddit'
import Facebook from '../components/social/Facebook'
import Twitter from '../components/social/Twitter'

const Header = styled.h1`
  align-self: end;
  margin: 3rem 3rem 0;

  a {
    display: block;
  }

  @media screen and (min-width: 640px) {
    width: 42rem;
  }
`

const Content = styled.p`
  align-items: start;
  align-self: start;
  display: grid;
  grid-template-columns: repeat(5, auto);
  margin: 3rem;

  a {
    display: block;
    margin-left: 3rem;

    &:first-child {
      margin-left: 0;
    }
  }

  @media screen and (min-width: 640px) {
    width: 42rem;
  }
`

const Index = ({
  data: {
    site: { metadata }
  }
}) => (
  <MainLayout>
    <Helmet>
      <link rel="canonical" href={metadata.url} />
      <meta property="og:url" content={metadata.url} />
    </Helmet>
    <Header>
      <a title="Insipid Studio" href="/">
        <Logo />
      </a>
    </Header>
    <Content>
      <Link title="Insipid Studio on Discord" href="https://discord.gg/2Xwx3ZK">
        <Discord />
      </Link>
      <Link
        title="Insipid Studio on Instagram"
        href="https://www.instagram.com/insipidstudio"
      >
        <Instagram />
      </Link>
      <Link
        title="Insipid Studio on Reddit"
        href="https://www.reddit.com/user/insipidstudio"
      >
        <Reddit />
      </Link>
      <Link
        title="Insipid Studio on Facebook"
        href="https://www.facebook.com/insipidstudio"
      >
        <Facebook />
      </Link>
      <Link
        title="Insipid Studio on Twitter"
        href="https://twitter.com/insipidstudio"
      >
        <Twitter />
      </Link>
    </Content>
  </MainLayout>
)

export default Index

export const query = graphql`
  query SiteUrl {
    site {
      metadata: siteMetadata {
        url
      }
    }
  }
`
